import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const tilopayOptions = {
  baseUrl: `${BACK_END_URL}/tilopay`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class TilopayClient extends CandyClient {
  constructor() {
    super(tilopayOptions);
  }

  async createPayment(paymentData) {
    
    return this.post(`/create-payment`, paymentData, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
  }

  async modifyTransaction(transactionData) {
    return this.post(`/modify-transaction`, transactionData, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
  }

  async consultTransaction(transactionId) {
    return this.post(`/consult-transaction`, { transactionId }, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
  }

  async confirmPayment(confirmationData) {
    return this.post(`/confirm`, confirmationData, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
  }

  async paymentHistory() {
    return this.get(`/history`, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
  }

  async paymentsByCourse(courseId) {
    return this.get(`/courses/students?courseId=${courseId}`, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
  }
}